exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.outer-popout-container{position:absolute;left:200px;top:86px;z-index:16;width:0;height:358px}.outer-popout-container .popout-container{position:absolute;left:10px;top:10px;z-index:16;width:219px;background-color:#fff;box-shadow:0 2px 13px 0 rgba(0,0,0,.2);overflow:visible;padding:24px}.outer-popout-container .popout-container .arrow-left{position:absolute;left:-10px;top:10px;width:0;height:0;border-top:10px solid transparent;border-bottom:10px solid transparent;border-right:10px solid #fff}.outer-popout-container .popout-container .popout-header{display:flex;height:25px;width:100%}.outer-popout-container .popout-container .popout-header .popout-title{margin-top:8px;margin-bottom:4px;margin-left:0;font-size:16px;font-family:Open Sans,sans-serif;font-weight:300;color:#4a4a4a;width:272px}.outer-popout-container .popout-container .popout-header .popout-close-icon{margin-top:-4px;height:18px;width:15px;cursor:pointer}.outer-popout-container .popout-container .button-container{display:flex;margin-left:110px}.outer-popout-container .popout-container .button-container .dialog-button{border-radius:4px;position:inherit!important}.outer-popout-container .popout-container .button-container .dialog-button~.dialog-button{margin-left:8px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/ProjectFilterPopout/ProjectFilterPopout.scss
// module id = 1603
// module chunks = 0